type VideoFileMp4 = 'video/mp4';

type CaptionKindSubtitles = 'subtitles';

type CaptionModeShowing = 'showing';
type CaptionModeDefault = 'default';

type CaptionSrcLangEn = 'en';

export type VideoOptions = {
  autoplay: boolean;
  controls: boolean;
  responsive: boolean;
  fluid: boolean;
  sources: [{
    src: string;
    type: VideoFileMp4
  }]
};

export type CaptionOptions = {
  kind: CaptionKindSubtitles;
  src: string;
  mode: CaptionModeShowing | CaptionModeDefault;
  srclang: CaptionSrcLangEn;
  label: string;
}

export const getVideoOptions = (src: string): VideoOptions => {
  return {
    autoplay: true,
    controls: true,
    responsive: true,
    fluid: true,
    sources: [{
      src: src,
      type: 'video/mp4',
    }],
  }
};

export const getCaptionOptions = (src: string): CaptionOptions => {
  return {
    kind: 'subtitles',
    src: src,
    mode: 'showing',
    srclang: 'en',
    label: 'subtitle 1',
  };
}